import { Component, Input, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { ButtonVM } from '../../factories/button.factory';
import { DialogService } from '../../services/dialog.service';

@Component({
  selector: 'app-edit-form',
  templateUrl: './edit-form.component.html',
  styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent implements OnInit {
  @Input() formId!: string;
  @Input() loaded: boolean = true;
  @Input() exitLink: any[] | string | null | undefined = '/'; // all types accepted by [routerLink]

  @Input() isSubmitting: boolean = false;
  @Input() legacy: boolean = false;
  @Input() isDialog?: boolean = false;

  @Input() buttons: ButtonVM[] = [];

  constructor(public rwdService: RWDService, private dialogService: DialogService) {}

  public onClickHandler(button: ButtonVM): void {
    if (button.isExit && this.isDialog) {
      button.onClick();
      this.dialogService.closeAllDialogs();
    } else {
      button.onClick();
    }
  }

  ngOnInit(): void {}
}
